import { MediaPickerComponent } from '@gripp/shared-logic';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { Colors } from '../../../themes/colors';
import { ControlledTextInput } from '../../forms';
import { AddMedia } from './addMedia';
import { RenderMediaSourceAdminForm } from './renderMediaSource';

const questionField = 'question';

type RoutineAdminInputTextProps = {
  control: Control;
  name: string;
  i18nPrefix: string;
  indexPrefix?: string;
  textArea?: boolean;
  mediaPicker?: MediaPickerComponent;
};

export const RoutineAdminInputText = (props: RoutineAdminInputTextProps) => {
  const { control, name, indexPrefix, textArea = false } = props;
  const fieldName = indexPrefix ? `${indexPrefix}.${name}` : name;

  return (
    <View style={styles.container}>
      <RoutineInstructions {...props} />
      <ControlledTextInput
        control={control}
        name={fieldName}
        textArea={textArea}
      />
    </View>
  );
};

const RoutineInstructions: React.FC<RoutineAdminInputTextProps> = (
  props: RoutineAdminInputTextProps
) => {
  const { indexPrefix, control } = props;
  const { t } = useTranslation();
  const fieldName = indexPrefix ? `${indexPrefix}.media` : 'media';
  // The attached-media affordance belongs to the `instructions` field only —
  // it reads/writes the single `${indexPrefix}.media` slot for the question
  // (or page). Gating on `i18nPrefix` alone isn't enough once a second
  // question-level field (e.g. `idpPrompt`) shares the same prefix: without
  // this check, both fields would render their own AddMedia/media-source
  // widgets bound to that same slot.
  const showMediaAttachment =
    props.name === 'instructions' && props.i18nPrefix.includes(questionField);

  return (
    <>
      <View>
        <Text style={styles.label}>
          {t(`${props.i18nPrefix}.${props.name}`)}
          {showMediaAttachment && (
            <AddMedia
              mediaPicker={props?.mediaPicker}
              control={control}
              fieldName={fieldName}
            />
          )}
        </Text>
      </View>
      {showMediaAttachment && (
        <RenderMediaSourceAdminForm control={control} fieldName={fieldName} />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 20,
  },
  label: {
    fontSize: 16,
    lineHeight: 16,
    color: Colors.role.textStrong,
    marginBottom: 10,
    fontWeight: '700',
  },
  closeImageIcon: {
    position: 'absolute',
    top: 5,
    right: 5,
    backgroundColor: Colors.primary,
    borderRadius: 8,
    cursor: 'pointer',
  },
});
